import React from 'react';
import { Breadcrumb as BreadcrumbComponent } from '../../components';

export default function Breadcrumb() {
	const crumbs = [
		{
			text: 'Explore',
		},
	];
	return <BreadcrumbComponent crumbs={crumbs} />;
}
